.logo {
  display: inline-block;
  flex-shrink: 0;
  /* Figma spec: neutral-900 (#171717) in light, pure white (#ffffff) in
   * dark. In light mode the hardcoded value matches --text-primary
   * exactly, so there is no practical delta. In dark mode --text-primary
   * resolves to #f5f5f5 (neutral-100, a slightly muted near-white)
   * rather than the Figma spec's pure #ffffff — that is the real
   * divergence that motivates explicit literals. The SVG root carries
   * `fill="currentColor"` so all paths pick up this local color.
   * When design exposes a semantic `--logo-color` token, swap the two
   * literals in one pass — same pattern StatusDot uses while waiting
   * for `--status-dot-color`. */
  color: #171717;
}

/* TODO: remove when --logo-color semantic alias lands. */
[data-theme="dark"] .logo {
  color: #ffffff;
}

/* ─── Sizes ──────────────────────────────────────────────────────── */
/* Height-only sizing; width scales from the SVG's viewBox aspect ratio
 * (78:24 ≈ 3.25:1) so the wordmark never distorts. Scale fills a
 * natural gap between `md` (Figma default) and `xl` (the largest
 * hero size) for mid-weight brand moments like the pairing screen,
 * where 24px reads small and 48px reads dominant. */

.size-sm {
  height: 20px;
  width: auto;
}

.size-md {
  height: 24px;
  width: auto;
}

.size-lg {
  height: 32px;
  width: auto;
}

.size-xl {
  height: 48px;
  width: auto;
}
